import { SimpleGrid as ChakraSimpleGrid } from "@chakra-ui/react";
import type { ComponentProps } from "react";

type ChakraSimpleGridProps = ComponentProps<typeof ChakraSimpleGrid>;

export type SimpleGridProps = ChakraSimpleGridProps & {
  /** Chakra v1/v2 compatibility */
  spacing?: ChakraSimpleGridProps["gap"];
  /** Chakra v1/v2 compatibility */
  spacingX?: ChakraSimpleGridProps["columnGap"];
  /** Chakra v1/v2 compatibility */
  spacingY?: ChakraSimpleGridProps["rowGap"];
};

export default function SimpleGrid(props: SimpleGridProps): JSX.Element {
  const { spacing, spacingX, spacingY, gap, columnGap, rowGap, ...rest } =
    props;

  return (
    <ChakraSimpleGrid
      gap={gap ?? spacing}
      columnGap={columnGap ?? spacingX}
      rowGap={rowGap ?? spacingY}
      {...(rest as unknown as ChakraSimpleGridProps)}
    />
  );
}
